import styled from 'styled-components';
import {IoIosAirplane} from 'react-icons/io';

export const IoAirplane = styled(IoIosAirplane)`
  color: #FFCE04;
`
